import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-scroll';
import logoImage from '../assets/logo.webp';
import whitepaper from '../assets/whitepaper.pdf'; // Asegúrate de tener el whitepaper en la carpeta assets

// Definir la animación de gradiente
const gradientAnimation = keyframes`
  0%, 100% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
`;

// Estilo para el contenedor de las letras con la animación de gradiente
const AnimatedTitle = styled.h1`
  font-size: 3.5rem;
  font-weight: 600;
  margin: 0;
  font-family: 'Raleway', sans-serif; /* Fuente llamativa */
  display: flex;

  span {
    background: linear-gradient(270deg, #9f00ff, #5f00ff, rgb(13, 240, 190));
    background-size: 400%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${gradientAnimation} 3s ease infinite;
  }
  
  span:nth-child(1) { animation-delay: 0s; }
  span:nth-child(2) { animation-delay: 0.3s; }
  span:nth-child(3) { animation-delay: 0.6s; }
  span:nth-child(4) { animation-delay: 0.9s; }
  span:nth-child(5) { animation-delay: 1.2s; }
  span:nth-child(6) { animation-delay: 1.5s; }
  span:nth-child(7) { animation-delay: 1.8s; }
`;

const Nav = styled.nav`
  background: #1a1a1a; /* Color oscuro como el del logo */
  color: #fff;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 10;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 0.5rem;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

const NavLink = styled(Link)`
  background: #0077b6;
  color: #fff;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease, color 0.3s ease, transform 0.3s ease;
  font-family: 'Raleway', sans-serif; /* Fuente llamativa */

  &:hover {
    background: #0093e9;
    color: #fff;
    transform: scale(1.05);
  }

  &.active {
    background: #005f99;
    color: #fff;
  }
`;

const DownloadButton = styled.a`
  background: #5f00ff;
  color: #fff;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease, color 0.3s ease, transform 0.3s ease;
  font-family: 'Raleway', sans-serif; /* Fuente llamativa */

  &:hover {
    background: rgb(13, 240, 190);
    color: #fff;
    transform: scale(1.05);
  }
`;

const Header = () => {
  return (
    <Nav>
      <LogoContainer>
        <Logo src={logoImage} alt="AdChain Logo" />
        <AnimatedTitle>
          <span>A</span>
          <span>d</span>
          <span>C</span>
          <span>h</span>
          <span>a</span>
          <span>i</span>
          <span>n</span>
        </AnimatedTitle>
      </LogoContainer>
      <NavLinks>
        <NavLink to="about" smooth={true} duration={500} activeClass="active">
          About
        </NavLink>
        <NavLink to="social" smooth={true} duration={500} activeClass="active">
          Social
        </NavLink>
        <NavLink to="roadmap" smooth={true} duration={500} activeClass="active">
          Roadmap
        </NavLink>
        <DownloadButton href={whitepaper} download>
          Whitepaper
        </DownloadButton>
      </NavLinks>
    </Nav>
  );
};

export default Header;
